var _rect, _path, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyStateEvent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "NoEvent",
    "data-name": "NoEvent",
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 200,
    viewBox: "0 0 250 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_19",
    "data-name": "Rettangolo 19",
    width: 250,
    height: 200,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Background",
    d: "M46,70a7,7,0,1,1,0-14H7A7,7,0,1,1,7,42H47a7,7,0,0,0,0-14H22a7,7,0,0,1,0-14H62A7,7,0,1,1,62,0h98a7,7,0,0,1,0,14H120a7,7,0,1,1,0,14h22a7,7,0,0,1,0,14H131.826C126.951,42,123,45.134,123,49s6,7,6,7a7,7,0,0,1,0,14ZM153,35a7,7,0,1,1,7,7A7,7,0,0,1,153,35Z",
    transform: "translate(41.5 63.447)",
    fill: "var(--color-empty-state-background, #f3f7ff)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5",
    "data-name": "Raggruppa 5",
    transform: "translate(-1379.587 -373.397) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_17",
    "data-name": "Rettangolo 17",
    transform: "translate(1377 644)",
    fill: "var(--color-surface, #ffffff)",
    stroke: "var(--color-empty-state-primary, #75a4fe)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 59,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 86.5,
    height: 56.5,
    rx: 2.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_18",
    "data-name": "Rettangolo 18",
    width: 81,
    height: 51,
    rx: 1,
    transform: "translate(1381 648)",
    fill: "var(--color-empty-state-surface, #e8f0fe)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4",
    "data-name": "Raggruppa 4",
    transform: "matrix(0.995, 0.105, -0.105, 0.995, -1221.254, -717.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_3",
    "data-name": "Rettangolo 3",
    transform: "translate(1384 648)",
    fill: "var(--color-surface, #ffffff)",
    stroke: "var(--color-empty-state-primary, #75a4fe)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 59,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 86.5,
    height: 56.5,
    rx: 2.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rettangolo_4",
    "data-name": "Rettangolo 4",
    d: "M1,0H83a1,1,0,0,1,1,1V14a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V1A1,1,0,0,1,1,0Z",
    transform: "translate(1386.5 650.5)",
    fill: "var(--color-empty-state-surface, #e8f0fe)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2",
    "data-name": "Raggruppa 2",
    transform: "translate(-0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linea_2",
    "data-name": "Linea 2",
    y2: 8,
    transform: "translate(1404.5 644)",
    fill: "none",
    stroke: "var(--color-empty-state-primary, #75a4fe)",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_3",
    "data-name": "Linea 3",
    y2: 8,
    transform: "translate(1416.5 644)",
    fill: "none",
    stroke: "var(--color-empty-state-primary, #75a4fe)",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_4",
    "data-name": "Linea 4",
    y2: 8,
    transform: "translate(1428.5 644)",
    fill: "none",
    stroke: "var(--color-empty-state-primary, #75a4fe)",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_5",
    "data-name": "Linea 5",
    y2: 8,
    transform: "translate(1440.5 644)",
    fill: "none",
    stroke: "var(--color-empty-state-primary, #75a4fe)",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_6",
    "data-name": "Linea 6",
    y2: 8,
    transform: "translate(1453.5 644)",
    fill: "none",
    stroke: "var(--color-empty-state-primary, #75a4fe)",
    strokeLinecap: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("line", {
    id: "Linea_7",
    "data-name": "Linea 7",
    x2: 86,
    transform: "translate(1385.5 665.5)",
    fill: "none",
    stroke: "var(--color-empty-state-primary, #75a4fe)",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3",
    "data-name": "Raggruppa 3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_5",
    "data-name": "Rettangolo 5",
    width: 8,
    height: 8,
    rx: 1,
    transform: "translate(1395 670)",
    fill: "var(--color-empty-state-on-background, #a4c3fe)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_16",
    "data-name": "Rettangolo 16",
    width: 8,
    height: 8,
    rx: 1,
    transform: "translate(1395 683)",
    fill: "var(--color-empty-state-on-background, #a4c3fe)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_10",
    "data-name": "Rettangolo 10",
    width: 8,
    height: 8,
    rx: 1,
    transform: "translate(1431 670)",
    fill: "var(--color-empty-state-on-background, #a4c3fe)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_6",
    "data-name": "Rettangolo 6",
    width: 8,
    height: 8,
    rx: 1,
    transform: "translate(1407 670)",
    fill: "var(--color-empty-state-on-background, #a4c3fe)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_15",
    "data-name": "Rettangolo 15",
    width: 8,
    height: 8,
    rx: 1,
    transform: "translate(1407 683)",
    fill: "var(--color-empty-state-on-background, #a4c3fe)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_9",
    "data-name": "Rettangolo 9",
    width: 8,
    height: 8,
    rx: 1,
    transform: "translate(1443 670)",
    fill: "var(--color-empty-state-on-background, #a4c3fe)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_7",
    "data-name": "Rettangolo 7",
    width: 8,
    height: 8,
    rx: 1,
    transform: "translate(1419 670)",
    fill: "var(--color-empty-state-on-background, #a4c3fe)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_14",
    "data-name": "Rettangolo 14",
    width: 8,
    height: 8,
    rx: 1,
    transform: "translate(1419 683)",
    fill: "var(--color-empty-state-on-background, #a4c3fe)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_8",
    "data-name": "Rettangolo 8",
    width: 8,
    height: 8,
    rx: 1,
    transform: "translate(1455 670)",
    fill: "var(--color-empty-state-on-background, #a4c3fe)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateEvent);
export default __webpack_public_path__ + "static/media/empty_state_event.b46d82ca8dac033692bea950735e5145.svg";
export { ForwardRef as ReactComponent };